import { useQuery } from '@tanstack/react-query';
import { useTranslation } from 'react-i18next';
import { ButtonPropsWithLabel } from 'src/components/Dialog';
import { fetchInvoices } from 'src/models/payment/payment';
import { formatCurrency } from 'src/utils/numberFormatter';

import { BlockingReasonFallback, BlockingReasonRow } from './BlockingReasonRow';

export function PaymentRequiredReason({
  userId,
  inlineActions = false,
}: {
  userId: string;
  inlineActions?: boolean;
}) {
  const { t } = useTranslation('translation', { keyPrefix: 'checkinBlocker' });

  const { data: invoices, isLoading: isLoadingInvoices } = useQuery({
    queryKey: ['invoices', userId],
    queryFn: () => fetchInvoices({ userId, filters: { status: 'open' } }),
  });

  const totalAmountDue =
    invoices?.invoices.reduce(
      (acc, invoice) => acc + (invoice.amountDue ?? 0),
      0
    ) ?? 0;

  const actions = [
    {
      label: t('actions.updatePaymentMethod'),
      variant: 'bordered',
    },
    {
      label: t('actions.override'),
      variant: 'borderless',
    },
  ] as ButtonPropsWithLabel[];

  if (isLoadingInvoices) {
    return <BlockingReasonFallback />;
  }

  return (
    <BlockingReasonRow
      title={t('blockingReasons.paymentRequired.title', {
        amount: formatCurrency(totalAmountDue),
      })}
      message={t('blockingReasons.paymentRequired.message')}
      actions={inlineActions ? actions : undefined}
    />
  );
}
